<template>
  <Form @submit="onSubmit">
    <div class="flex border-b border-dark-b">
      <h2 class="text-xl md:text-2xl font-semibold mr-6 w-9/12 md:w-1/2">Payment Details</h2>
      <div class="flex items-center text-xs md:w-1/2 justify-end md:justify-between">
        <div>Progress</div>
        <div class="flex w-10/12 items-center justify-between">
          <div class="hidden md:inline w-1/5 h-2 ml-2 bg-green rounded-full"/>
          <div class="hidden md:inline w-4/5 h-2 bg-white rounded-r-full"/>
          <div class="pl-2 text-green md:text-black">20%</div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap w-full pt-7 md:pt-12">
      <div class="lg:pr-5 w-full font-semibold text-lg lg:text-xl lg:w-1/2">
        <div class="pb-1">Full Name on Bank Account<span class="text-error">*</span></div>
        <Field
          name="account_holder_name"
          class="form-input text-sm lg:text-lg"
          placeholder="Type ID Full Name here..."
          :rules="isRequired"
          v-model="formData.account_holder_name"
        />
        <div class="h-5 md:h-8">
          <ErrorMessage name="account_holder_name" class="form-error"/>
        </div>
      </div>
      <div class="lg:pl-5 font-semibold text-lg lg:text-xl w-full lg:w-1/2">
        <div class="pb-1">Bank Account Number<span class="text-error">*</span></div>
        <Field
          name="account_number"
          class="form-input text-sm lg:text-lg"
          placeholder="Type Account Number here..."
          :rules="isRequired"
          v-model="formData.account_number"
        />
        <div class="h-5 md:h-8">
          <ErrorMessage name="account_number" class="form-error"/>
        </div>
      </div>     
    </div>
    <div class="flex flex-wrap w-full">
      <div class="lg:pr-5 w-full font-semibold text-lg lg:text-xl lg:w-1/2">
        <div class="pb-1">Bank Name<span class="text-error">*</span></div>
        <Field
          name="bank_name"
          class="form-input text-sm lg:text-lg"
          placeholder="Type Bank Name here..."
          :rules="isRequired"
          v-model="formData.bank_name"
        />
        <div class="h-5 md:h-8">
          <ErrorMessage name="bank_name" class="form-error"/>
        </div>
      </div>
      <div class="lg:pl-5 font-semibold text-lg lg:text-xl w-full lg:w-1/2">
        <div class="pb-1">Swift Code<span class="text-error">*</span></div>
        <Field
          name="swift_code"
          class="form-input text-sm lg:text-lg"
          placeholder="Type Swift Code here..."
          :rules="isRequired"
          v-model="formData.swift_code"
        />
        <div class="h-5 md:h-8">
          <ErrorMessage name="swift_code" class="form-error"/>
        </div>
      </div>     
    </div>
    <div class="flex flex-wrap w-full">
      <div class="lg:pr-5 w-full font-semibold text-lg lg:text-xl lg:w-1/2">
        <div class="pb-1">Branch Name<span class="text-error">*</span></div>
        <Field
          name="branch_name"
          class="form-input text-sm lg:text-lg"
          placeholder="Type Branch Name here..."
          :rules="isRequired"
          v-model="formData.bank_branch_name"
        />
        <div class="h-5 md:h-8">
          <ErrorMessage name="branch_name" class="form-error"/>
        </div>
      </div>
      <div class="lg:pl-5 font-semibold text-lg lg:text-xl w-full lg:w-1/2">
        <div class="pb-1">Bank Branch Code
          <span class="pl-1 relative" 
            @mouseenter="showBankBranchCodeDetails = true"
            @mouseleave="showBankBranchCodeDetails = false"
          >
            ⓘ
            <span class="text-error">*</span>
            <div
              v-if="showBankBranchCodeDetails"
              class="absolute z-20 lg2:-top-8 ml-2 lg2:left-5 right-0 pt-2 px-3"
            >
              <div class="px-2 py-2 w-52 text-xs font-normal border rounded-lg bg-gray-b">
                Typically, a 3-digit code; please check with your bank if you are unsure.
              </div>
            </div>
          </span>
        </div>
        <Field
          name="bank_code"
          class="form-input text-sm lg:text-lg"
          placeholder="Type Bank Branch Code here..."
          :rules="isRequired"
          v-model="formData.bank_code"
        />
        <div class="h-5 md:h-8">
          <ErrorMessage name="bank_code" class="form-error"/>
        </div>
      </div>     
    </div>
    <div class="flex flex-wrap w-full">
      <div class="w-full font-semibold text-lg lg:text-xl">
        <div class="pb-1">Branch Address<span class="text-error">*</span></div>
        <Field
          name="branch_address"
          type="textarea"
          :rules="isRequired"
          v-model="formData.bank_branch_address"
          v-slot="{field}"
        >
          <textarea 
            v-bind="field"
            class="border border-dark-b px-3 py-3 w-full text-sm lg:text-lg rounded-lg bg-white h-28 max-h-28 md:h-14 md:max-h-14" 
            placeholder="Type Branch Address here..." 
          />
        </Field>
        <div class="lg:h-9">
          <ErrorMessage name="branch_address" class="form-error"/>
        </div>
      </div>
    </div>
    <div class="flex justify-end pt-6 pb-6">
      <button
        class="bg-blue text-white py-3 px-12 rounded-full font-bold"
      >
        Save
      </button>
    </div>
  </Form>
</template>
<script>
import { mapActions } from 'vuex'
import VeeValidate from '@/shared/mixins/VeeValidate'

export default {
  name: 'PaymentDetails',
  mixins: [VeeValidate],
  data() {
    return {
      formData: {},
      showBankBranchCodeDetails: false
    }
  },
  methods: {
    ...mapActions([
      'updatePaymentInformation'
    ]),
    async onSubmit() {
      const response = await this.updatePaymentInformation(this.formatFormData())
      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message
      })
    },
    formatFormData() {
      const userData = new URLSearchParams()
      Object.keys(this.formData).forEach(key => {
        userData.append(key, this.formData[key] || '')
      })
      return userData
    }
  }
}
</script>
